import styled from 'styled-components'

export const RadioButtonLabel = styled.label`
  padding-left: 5px;
`

export const RadioButtonContainer = styled.div`
  padding: 10px;
`
